import { Pipe, PipeTransform } from '@angular/core';


const counters = new WeakMap<any, Counter>();

@Pipe({
  name: 'counterPipe'
})

export class CounterPipe implements PipeTransform  {
  transform(value: any): Counter {
    if (!counters.has(value)) {
      counters.set(value, new Counter());
    }
    return counters.get(value);
  }
}

export class Counter {
    private value = 1;
    reset() {
      this.value = 1;
    }
    inc(): number {
      return this.value++;
    }
  }
